export default {
    'multiple-languages': {
        title: 'Versión 2.3: Keybreak habla siete idiomas',
        excerpt: 'La versión 2.3 trae compatibilidad con varios idiomas: toda la aplicación y el sitio web están ya disponibles en siete idiomas, y llegarán más.',
    },
    'micro-breaks': {
        title: 'Versión 2.2: micropausas',
        excerpt: 'Tras los comentarios de algunos usuarios, la versión 2.2 añade las micropausas: un aviso pequeño en una esquina de la pantalla cada 10–15 minutos con una cosa que probar.',
    },
    'dynamic-hold-system': {
        title: 'Versión 2.1: mantenimientos más inteligentes y mejor información',
        excerpt: 'La versión 2.1 añade dos cosas: una forma de alargar el tiempo de mantenimiento sobre la marcha y un nuevo sistema de animaciones que te muestra exactamente en qué punto estás de cada mantenimiento.',
    },
    'science-of-sitting': {
        title: 'La ciencia del sedentarismo: qué nos dice la investigación sobre pasar el día sentados',
        excerpt: 'El sedentarismo es un riesgo para la salud por sí mismo, en buena medida al margen de si haces ejercicio o no. Esto es lo que muestra la investigación.',
    },
    'benefits-of-moving': {
        title: 'Por qué moverte más durante tu jornada laboral sí importa',
        excerpt: 'Las pausas para moverte no solo le vienen bien a tu cuerpo: te dejan más despierto, menos cansado y más productivo a lo largo del día.',
    },
    'keybreak-launch': {
        title: 'Keybreak: te presentamos tu compañero inteligente de pausas',
        excerpt: 'Después de meses de desarrollo, nos hace mucha ilusión anunciar que Keybreak ya está disponible oficialmente: descarga gratuita para Mac y Windows.',
    },
}
